//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import iProgress from '../progress/progress.vue';
const prefixCls = 'ivu-upload';

export default {
    name: 'UploadList',
    components: { iProgress },
    props: {
        files: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data () {
        return {
            prefixCls: prefixCls
        };
    },
    methods: {
        fileCls (file) {
            return [
                `${prefixCls}-list-file`,
                {
                    [`${prefixCls}-list-file-finish`]: file.status === 'finished'
                }
            ];
        },
        handleClick (file) {
            this.$emit('on-file-click', file);
        },
        handlePreview (file) {
            this.$emit('on-file-preview', file);
        },
        handleRemove (file) {
            this.$emit('on-file-remove', file);
        },
        format (file) {
            const format = file.name.split('.').pop().toLocaleLowerCase() || '';
            let type = 'icon icon-document';

            if (['gif','jpg','jpeg','png','bmp','webp'].indexOf(format) > -1) {
                type = 'icon icon-image';
            }
            if (['mp4','m3u8','rmvb','avi','swf','3gp','mkv','flv'].indexOf(format) > -1) {
                type = 'icon icon-ios-film';
            }
            if (['mp3','wav','wma','ogg','aac','flac'].indexOf(format) > -1) {
                type = 'icon icon-ios-musical-notes';
            }
            if (['doc','txt','docx','pages','epub','pdf'].indexOf(format) > -1) {
                type = 'icon icon-document-text';
            }
            if (['numbers','csv','xls','xlsx'].indexOf(format) > -1) {
                type = 'icon icon-stats-bars';
            }
            if (['keynote','ppt','pptx'].indexOf(format) > -1) {
                type = 'icon icon-ios-videocam';
            }

            return type;
        },
        parsePercentage (val) {
            return parseInt(val, 10);
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/upload/upload-list.vue